import axios, { type AxiosInstance } from "axios";
import { HTTP_CONFIG } from "../constants";

const created = typeof axios.create === "function" 
  ? axios.create({
      timeout: HTTP_CONFIG.REQUEST_TIMEOUT_MS,
    }) 
  : undefined;

const fallback: any = axios as unknown;
if (!created && (!fallback?.interceptors?.request || !fallback?.interceptors?.response)) {
	fallback.interceptors = {
		request: { use: () => 0, eject: () => {} },
		response: { use: () => 0, eject: () => {} },
	};
}

export const apiClient: AxiosInstance = (created ?? fallback) as AxiosInstance;

// Default headers (do not force Content-Type for FormData uploads)
apiClient.interceptors.request.use((config) => {
	const headers: any = (config as any).headers ?? {};
	(config as any).headers = headers;

	const hasContentType = Object.keys(headers).some(
		(k) => k.toLowerCase() === "content-type"
	);
	const hasAccept = Object.keys(headers).some((k) => k.toLowerCase() === "accept");

	if (!hasAccept) {
		headers["Accept"] = "application/json";
	}

	const data: any = (config as any).data;
	const isFormData =
		typeof FormData !== "undefined" && data != null && data instanceof FormData;

	// Only set JSON content-type when sending a body and it's not FormData
	if (!hasContentType && data != null && !isFormData) {
		headers["Content-Type"] = "application/json";
	}

	return config;
});

export default apiClient;
